export default __webpack_public_path__ + "static/media/MaskGroup5.282c0ad8.png";